// extracted by mini-css-extract-plugin
export default {"container":"BaseCheckbox_container_VsKKP","label":"BaseCheckbox_label_rMBiO","input":"BaseCheckbox_input_Y48Pa","error":"BaseCheckbox_error__lRfu"};